<app-billing-invoice-edit [enabledClientSearch]="enabledClientSearch" *ngIf="!loading"></app-billing-invoice-edit>